import { render, staticRenderFns } from "./singleUpload.vue?vue&type=template&id=6ba509a8&scoped=true&"
import script from "./singleUpload.vue?vue&type=script&lang=js&"
export * from "./singleUpload.vue?vue&type=script&lang=js&"
import style0 from "./singleUpload.vue?vue&type=style&index=0&id=6ba509a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba509a8",
  null
  
)

export default component.exports